// extracted by mini-css-extract-plugin
export default {"ModuleUploadDataButton":"ModuleUploadDataButton_ModuleUploadDataButton__ApEaU","Icon":"ModuleUploadDataButton_Icon__EQiIp"};